<section class="contact-us">
  <div class="relationship-summary__contact">
    <div class="relationship-summary__contact--title">
      <h3>Need Help?</h3>
      <srm-button [config]="emailUsButtonConfig" />
    </div>
    <div class="relationship-summary__contact--content">
      <div class="relationship-summary__contact--content__info">
        <div class="relationship-summary__logo">
          <img [src]="contact.companyLogo" alt="{{ contact.companyName }}" />
          <label>{{ contact.companyName }}</label>
        </div>
        <div class="contact-information">
          <a href="{{ contact.mapURL }}" class="contact-line-item" target="_blank">
            <srm-icon [config]="mapIconConfig"></srm-icon>
            <span>{{ contact.address }}</span>
          </a>
          <a href="tel:{{ parsedPhone }}" class="contact-line-item">
            <srm-icon [config]="phoneIconConfig"></srm-icon>
            <span>{{ contact.phone }}</span>
          </a>

          <a href="mailto:{{ contact.email }}?subject=SRM Momentum Help" class="contact-line-item">
            <srm-icon [config]="emailIconConfig"></srm-icon>
            <span>{{ contact.email }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
